import React, { useEffect } from 'react';
import { CloseIcon } from '@bizzabo/icons';
import { sendAnalytics } from 'utils/analyticsUtils';
import BZModal from 'BZModal';


const modelTexts = {
    THIRD_PARTY_COOKIES_BLOCKED: {
        title: 'Please enable 3rd party cookies',
        description: 'We use cookies to show your personalized agenda, broadcast virtual sessions, and offer engagement tools. Without enabling them, you will not be able to complete the login.',
        helpCenterLinkText: 'Click here to learn how to enable 3rd party cookies for this website'
    },
    FIRST_PARTY_COOKIES_BLOCKED: {
        title: 'Please enable cookies',
        description: 'We use cookies to show your personalized agenda, broadcast virtual sessions, and offer engagement tools. Without enabling them, you will not be able to complete the login.',
        helpCenterLinkText: 'Click here to learn how to enable cookies for this website'
    },
    KALTURA_THIRD_PARTY_COOKIES_BLOCKED: {
        title: 'Please enable 3rd party cookies to join the broadcast',
        description: 'We use cookies to broadcast virtual sessions. Without enabling them, you will not be able to join the broadcast.',
        helpCenterLinkText: 'Click here to learn how to enable 3rd party cookies for this website'
    },

};

const isIframe = window.self !== window.parent;

const ThirdPartyCookieModal = ({
    show,
    onHide,
    isInteractSession,
    onNewTabSolution,
}) => {
    useEffect(() => {
        if (show) {
            if (isIframe) {
                sendAnalytics('show3rdPartyCookiesDialog');
            }
            if (!isIframe && !isInteractSession) {
                sendAnalytics('showCookiesDialog');
            }
        }
    }, [show]);

    const textsToShow = isIframe
        ? modelTexts.THIRD_PARTY_COOKIES_BLOCKED
        : isInteractSession
            ? modelTexts.KALTURA_THIRD_PARTY_COOKIES_BLOCKED
            : modelTexts.FIRST_PARTY_COOKIES_BLOCKED;

    const openNewTab = () => {
        if (typeof onNewTabSolution === 'function') {
            onNewTabSolution();
        } else {
            window.open(window.self.location.href, '_blank');
        }
    };

    return <BZModal
        modalCls="agenda-modal third-party-cookie-modal"
        color='white'
        show={show}
        onHide={onHide}
        hideFooter
    >
        <button className="close-btn custom-color color-1-background color-1-hover-opacity" onClick={onHide}>
            <CloseIcon fill="var(--page-contrast-to-main-color, #fff)"/>
        </button>
        <div className="inner-container custom-font">
            <div className={'cookie-image-container'}><img className={'cookie-image'}
                src={'https://assets-ext.bizzabo.com/bizzabo/image/upload/q_auto:best,c_crop,g_custom/v1592219776/modwzlkxecylmmtigfxn.png'}/>
            </div>

            <div className="text-center">
                <h4 className="modal-title margin-small">{textsToShow?.title}</h4>
                <div className="modal-text padding-horizontal-medium">
                    {textsToShow?.description}
                </div>
                <div className="margin-top-medium margin-bottom-small">
                    <a
                        href='https://welcome.bizzabo.com/en/en/3rd-party-cookies-how-to'
                        target='_blank'
                        rel="noreferrer"
                        className="color-1 modal-link"
                    >
                        {textsToShow?.helpCenterLinkText}
                    </a>
                </div>
                {(isIframe || isInteractSession) && (
                    <div className="margin-top-medium margin-bottom-small">
                        {`Or open this ${
                            isInteractSession ? 'broadcast' : 'content'
                        } in a `}
                        <button
                            className="color-1 custom-font padding-none border-transparent background-none"
                            onClick={openNewTab}
                        >
                            new tab
                        </button>
                    </div>
                )}
            </div>
        </div>
    </BZModal>;
};

export default ThirdPartyCookieModal;
